import { create } from 'zustand';

type TArticleViewStore = {
  articleId: string | null;
  progress: number;
  setArticleId: (id: string | null) => void;
  setProgress: (progress: number) => void;
};

export const useArticleViewStore = create<TArticleViewStore>((set) => ({
  articleId: null,
  progress: 0,
  setArticleId: (articleId) => set({ articleId }),
  setProgress: (progress) => set({ progress }),
}));
